<template>
    <B2D></B2D>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const B2D = defineAsyncComponent(() =>
    import("../../components/Logistics/B2D.vue")
);

export default {
    name: "B2D_Form", //The name you are in should not equal the name of the component you are importing.
    components: { B2D, AuthLayout },
};
</script>
